// main.ts / entry.ts
import { createSSRApp } from "vue";
import App from "./App.vue";
import { setupStore } from "./store";

// 仅开发环境监听 & 看门狗 —— 生产构建会被整段裁掉
if (import.meta.env.DEV) {
  window.addEventListener("error", (e) => {
    // dev 调试保留
    // eslint-disable-next-line no-console
    console.error("[GlobalError]", e.message, e.filename, e.lineno, e.colno);
  });
  window.addEventListener("unhandledrejection", (e) => {
    // eslint-disable-next-line no-console
    console.error("[UnhandledRejection]", e.reason);
  });

  // 首屏看门狗只在开发启用
  const watchdog = setTimeout(() => {
    const tip = document.createElement("div");
    tip.style.cssText = "padding:12px;font:14px/1.6 system-ui";
    tip.innerHTML = '加载超时，<a href="javascript:location.reload()">点击重试</a>';
    document.body.appendChild(tip);
    // eslint-disable-next-line no-console
    console.warn("[Watchdog] 页面10s内没加载出来");
  }, 10000);
  // 等待框架 mount 后清除
  queueMicrotask(() => clearTimeout(watchdog));
}

export function createApp() {
  const app = createSSRApp(App);

  if (import.meta.env.DEV) {
    // 仅开发环境兜底日志，生产不带 console
    app.config.errorHandler = (err, _vm, info) => {
      // eslint-disable-next-line no-console
      console.error("[VueError]", err, info);
    };
  }

  // ❌ 不要全量：app.use(uviewPlus)
  // ✅ 按需：见下方 Vite 配置（自动引入组件）
  setupStore(app);

  return { app };
}
